import monthAsText from '@utils/date/monthAsText'

export default function friendlyDate (ts, useT, full = false) {
    const date = new Date(ts)

    const year = date.getFullYear()
    const month = date.getMonth()
    const day = date.getDate()
    const hour = date.getHours()
    const minute = date.getMinutes()

    const monthText = monthAsText(month, useT)

    return full
        ? `${ day } ${ monthText } ${ hour }:${ minute < 10 ? '0' + minute : minute }`
        : `${ day } ${ monthText } ${ year }`
}

export { monthAsText }